import { gql } from "@apollo/client";
export const GET_STUDENT_NOTES = gql(`query StudentNotes($studentId:UUID!){
  student(id:$studentId){
    __typename
    id
    firstName
    lastName
    allNotes {
        id
        body
        id
        type
        origin
        sessionNotes{
            session{
                id
                createdAt
            }
        }
        createdAt
        person{
            id
            firstName
            lastName
            role{
                normalizedName}
            }
    }
  }
}
`);
